import React from "react";

const CheckBoxMC = ({
  id,
  name,
  checked,
  onChange,
  className = '',
  children
}) => (
  <li className="tw-flex tw-items-center">
    <input
      id={id}
      name={name}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className={`tw-form-checkbox tw-h-4 tw-w-4 tw-text-blue-500 tw-accent-blue-500 tw-transition tw-duration-150 tw-ease-in-out ${className}`}
    />
    {children && (<div className="tw-ml-2">{children}</div>)}
  </li>
);

export default CheckBoxMC;
